import { getUrl } from 'aws-amplify/storage';

/** Candidate S3 keys for Amplify Storage — handles with/without `public/` prefix. */
export function storagePathCandidates(path: string): string[] {
    const trimmed = path.trim();
    if (!trimmed) {
        return [];
    }

    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return [trimmed];
    }

    const candidates = new Set<string>([trimmed]);
    if (trimmed.startsWith('public/')) {
        candidates.add(trimmed.slice('public/'.length));
    } else {
        candidates.add(`public/${trimmed}`);
    }

    return [...candidates];
}

export async function resolveStorageImageUrl(path: string | null | undefined): Promise<string | null> {
    if (!path?.trim()) {
        return null;
    }

    const trimmed = path.trim();
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return trimmed;
    }

    for (const candidate of storagePathCandidates(trimmed)) {
        try {
            const result = await getUrl({ path: candidate });
            return result.url.href;
        } catch {
            /* try next candidate */
        }
    }

    return null;
}
